import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', () => {
  const _navigation = ref([])
  const _tabs = ref([])

  const navigation = computed(() => _navigation.value)
  const tabs = computed(() => _tabs.value)

  const setTabs = (newTabs) => {
    _tabs.value = newTabs
  }

  const setNavigation = (newNavigation) => {
    _navigation.value = newNavigation
  }

  return { navigation, tabs, setNavigation, setTabs }
})
